import { notEmpty, type Optional } from '@festina-life/core'
import { useTranslate } from '@festina-life/ui/hooks'

import type {
  SimpleValueSetupField,
  SubTemplateFieldValue,
} from '../../../types/templateModel'

type Props = {
  variant: Optional<SubTemplateFieldValue>
}
export const CcCalcStepFieldPriority = ({ variant }: Props) => {
  const translate = useTranslate()

  const priorityField = variant?.fields.find(
    (field) => field.name === 'priority',
  ) as SimpleValueSetupField
  const variantPriority =
    priorityField?.value?.defaultValue?.expression?.fplusSource

  return notEmpty(variantPriority) ? (
    <div className="text-sm opacity-60 pl-4">
      {translate('templateViewer.ccdVariant.priority', {
        priority: variantPriority,
      })}
    </div>
  ) : null
}
